import './TitleWithText.css';
import * as React from 'react';
import TitleBar from "../../Components/TitleBar/TitleBar";

class TitleWithText extends React.Component {
  render() {
    return (
        <div style={this.props.style} className={this.props.className}>
          <TitleBar align="left" startIcon={this.props.startIcon} endIcon={this.props.endIcon}>
            {this.props.title}
          </TitleBar>
          <div className="title-with-text">
            {this.props.children}
          </div>
        </div>
    );
  }
}

export default TitleWithText;
